import { PROD_CLIENT_ID, TEST_CLIENT_ID } from '../consts'
import { isProd } from './isProd'

export const getClientId = () => {
    if (isProd()) {
        return PROD_CLIENT_ID
    }

    return TEST_CLIENT_ID
}
